export default "__VITE_PUBLIC_ASSET__5b71d8fc__"